import React, {useCallback, useEffect, useState, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import './ModelList.css';
import GetAccessToken from './Tokens'
import { useConfig } from './ConfigContext';

const cachedModels = {};

const ModelList = ({setModel, group_id, listTitle, specimenList}) => {
    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState(null);
    const [modelServiceUrl, setModelServiceUrl] = useState(null);
    const [groupServiceUrl, setGroupServiceUrl] = useState(null);
    const [webglUrl, setWebglUrl] = useState(null);
    const navigate = useNavigate();
    const currentRequestRef = useRef(null);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setModelServiceUrl(config["model_service_url"]);
            setWebglUrl(config["webgl_url"]);
            setGroupServiceUrl(config["group_service_url"]);
        }
    }, [config]);

    const getModelsList = useCallback((modelServiceUrl, groupServiceUrl, navigate) => {
        const loadModelData = (id) => {
            currentRequestRef.current = id;
            let url = modelServiceUrl + '/public/list';
            if (id != null) {
                url = groupServiceUrl + '/public/specimens?group_id=' + id;
            }
            return fetch(url, {
            })
                .then(response => {
                    if (response.status === 401) {
                        sessionStorage.removeItem('access_token');
                        console.error('Unauthorized:', response.statusText);
                        return loadModelData(id);
                    }
                    return response.json();
                })
                .then(data => {
                    if (data && data.specimens) {
                        const specimenNames = data.specimens.map(specimen => specimen.specimen_name);
                        cachedModels[id] = specimenNames;
                        if (currentRequestRef.current === id) {
                            setModels(specimenNames);
                        }
                        return specimenNames;
                    }
                    return [];
                })
                .catch(error => {
                    if (error.message !== 'Unauthorized') {
                        console.error('Error fetching the models:', error);
                    }
                });
        };

        if (cachedModels[group_id]) {
            setModels(cachedModels[group_id]);
        } else if (group_id) {
            // Load current group_id data
            loadModelData(group_id).then(currentModels => {
                if (currentModels) {
                    setModels(currentModels);
                }
            });
        }
    }, [group_id]);

    useEffect(() => {
        if (specimenList !== undefined) {
            setModels(specimenList);
        }
        else if (modelServiceUrl && groupServiceUrl) {
            getModelsList(modelServiceUrl, groupServiceUrl, navigate);
        }
    }, [modelServiceUrl, groupServiceUrl, navigate, getModelsList, group_id]);

    const handleModelSelect = (model) => {
        setSelectedModel(model);
        setModel(model);
    };

    return (
        <div className="model-list">
            <h4>{listTitle}</h4>
            <ul>
                {models.map((model, index) => (
                    <li key={index} onClick={() => handleModelSelect(model)}>
                        {model}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ModelList;
